<template>
  <li
    class="p-config-contract-usages__item"
    :class="{
      'p-config-contract-usages__item--project': isProject || isProjectChild,
      'p-config-contract-usages__item--project-child': isProjectChild
    }"
  >
    <h4 class="p-config-contract-usages__title">
      {{ label }}
    </h4>
    <p class="p-config-contract-usages__count">
      <span class="current" :class="{ 'is-over': isOver }">{{ current }}</span>
      <span>/</span>
      <span class="max">{{ max }}</span>
    </p>
    <div v-if="hasGraph" class="p-config-contract-usages-graph">
      <div
        class="p-config-contract-usages-graph__bar"
        :class="{ 'is-over': isOver }"
        :style="{ width: barWidth + '%' }"
      ></div>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    hasGraph: {
      type: Boolean,
      required: false
    },
    label: {
      type: String,
      required: true
    },
    current: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    },
    variant: {
      type: String,
      required: false
    }
  },
  computed: {
    barWidth() {
      if (!this.current) {
        return 0;
      }
      return (this.current / this.max) * 100;
    },
    isOver() {
      return this.current >= this.max;
    },
    isProject() {
      return this.variant === 'project';
    },
    isProjectChild() {
      return this.variant === 'project-child';
    }
  }
};
</script>
